const DeviceClass = Object.freeze({
  Router: 'router',
  Switch: 'switch',
  Firewall: 'firewall',
  LoadBalancer: 'load_balancer',
  SdwanGateway: 'sd_wan_gateway',
  WirelessController: 'wireless_controller',
  AccessPoint: 'wireless_access_point',
  Server: 'server',
  UPS: 'ups',
  PDU: 'pdu',
  OpticalTransport: 'optical_transport',
  StorageArray: 'storage_array',
  SecurityAppliance: 'security_appliance'
});

const DEFAULT_DEVICE_CLASS = DeviceClass.Router;

module.exports = {
  DeviceClass,
  DEFAULT_DEVICE_CLASS
};
